import R from 'ramda'

export const getValidPlantList = (plantList, inverterGroup) => {
  // plantId must in inverterGroup

  const storagePlantCore = plantList.map(p => p.plantId)

  const inverterPlantIds = R.compose(
    R.uniq,
    R.map(g => g.plantId)
  )(inverterGroup)

  const nercReportingPlants = R.compose(
    R.sortBy(R.prop('plantName')),
    R.map(id => plantList.find(f => f.plantId === id)),
    R.filter(id => inverterPlantIds.includes(id))
  )(storagePlantCore)

  return nercReportingPlants
}

export const getStoragePlantListNercReportingAllowing = (
  plantList,
  inverterGroup,
  storageGroup
) => {
  // this is for Nerc Reporting Storage Plant
  // nerc repoting means  plant map in inverterGroup and storageGroup
  const storagePlantCore = plantList
    .filter(
      f =>
        f.onSiteStorage === 'Y' ||
        f.onSiteStorage === 'y' ||
        f.onSiteStorage === 'YES'
    )
    .map(p => p.plantId)

  const inverterPlantIds = R.compose(
    R.uniq,
    R.map(g => g.plantId)
  )(inverterGroup)

  const storagePlantIds = R.compose(
    R.uniq,
    R.map(g => g.plantId)
  )(storageGroup)

  const nercReportingPlants = R.compose(
    R.sortBy(R.prop('plantName')),
    R.map(id => plantList.find(f => f.plantId === id)),
    R.filter(
      id => inverterPlantIds.includes(id) && storagePlantIds.includes(id)
    )
  )(storagePlantCore)

  return nercReportingPlants
}

export const getStoragePlantListNercReportingAllowingNot = (
  plantList,
  inverterGroup,
  storageGroup
) => {
  // this is for Nerc Reporting Storage Plant
  // not nerc repoting means  plant map in storageGroup but its NOT in  inverterGroup
  const storagePlantCore = plantList
    .filter(
      f =>
        f.onSiteStorage === 'Y' ||
        f.onSiteStorage === 'y' ||
        f.onSiteStorage === 'YES'
    )
    .map(p => p.plantId)

  const inverterPlantIds = R.compose(
    R.uniq,
    R.map(g => g.plantId)
  )(inverterGroup)

  const storagePlantIds = R.compose(
    R.uniq,
    R.map(g => g.plantId)
  )(storageGroup)

  const nercReportingPlants = R.compose(
    R.sortBy(R.prop('plantName')),
    R.map(id => plantList.find(f => f.plantId === id)),
    R.filter(
      id => !inverterPlantIds.includes(id) && storagePlantIds.includes(id)
    )
  )(storagePlantCore)

  return nercReportingPlants
}

export const getValidStoragePlantList = (
  plantList,
  inverterGroup,
  storageGroup
) => {
  // this is for Nerc Reporting Storage Plant
  // not nerc repoting means  plant map in storageGroup but its NOT in  inverterGroup
  const storagePlantCore = plantList
    .filter(
      f =>
        f.onSiteStorage === 'Y' ||
        f.onSiteStorage === 'y' ||
        f.onSiteStorage === 'YES'
    )
    .map(p => p.plantId)

  const storagePlantIds = R.compose(
    R.uniq,
    R.map(g => g.plantId)
  )(storageGroup)

  const validStoragePlant = R.compose(
    R.sortBy(R.prop('plantName')),
    R.map(id => plantList.find(f => f.plantId === id)),
    R.filter(id => storagePlantIds.includes(id))
  )(storagePlantCore)

  return validStoragePlant
}

export const getValidActivePlantList = (
  plantList,
  inverterGroup,
  activePlantIds
) => {
  const storagePlantCore = plantList.map(p => p.plantId)

  const inverterPlantIds = R.compose(
    R.uniq,
    R.map(g => g.plantId)
  )(inverterGroup)

  const validActivePlant = R.compose(
    R.sortBy(R.prop('plantName')),
    R.map(id => plantList.find(f => f.plantId === id)),
    R.filter(id => inverterPlantIds.includes(id)),
    R.filter(id => activePlantIds.includes(id))
  )(storagePlantCore)

  return validActivePlant
}

export const getValidActivePlantWithStorageGroup = (
  plantList,
  storageGroup,
  activePlantIds
) => {
  const storagePlantCore = plantList
    .filter(
      f =>
        f.onSiteStorage === 'Y' ||
        f.onSiteStorage === 'y' ||
        f.onSiteStorage === 'YES'
    )
    .map(p => p.plantId)
  const storagePlantIds = R.compose(
    R.uniq,
    R.map(g => g.plantId)
  )(storageGroup)

  const validActivePlant = R.compose(
    R.sortBy(R.prop('plantName')),
    R.map(id => plantList.find(f => f.plantId === id)),
    R.filter(id => storagePlantIds.includes(id)),
    R.filter(id => activePlantIds.includes(id))
  )(storagePlantCore)

  return validActivePlant
}
